module.exports = __webpack_public_path__ + "static/travel-logo-purple-144-ab2a3138e6f4967c687c48d0fb7d4bdc.png";